module.exports = __webpack_public_path__ + "static/assets/9849f8539269d0151f613fe01299cb46.png";